import {i18n} from '@yourcoach/i18n';

import type {ChannelCourseResource} from '../../../../../api/channel';
import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {getCourseLabel} from '../../../../../utils/entity/course';
import {ChannelInfoStore} from '../../../../channel';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, complaint, post} = contexts;

  const data: EventData = {};

  if (post && post.channel) {
    const channelInfoStore = new ChannelInfoStore({
      channel: post.channel,
      channelId: post.channel_id,
    });

    const courseLabel =
      post.channel && post.channel.type === 'course'
        ? getCourseLabel(post.channel.resource as ChannelCourseResource)
        : '';

    const channelTitle = channelInfoStore.title || 'Channel not found';

    data.avatar = channelInfoStore.avatar;
    data.avatarPlaceholder = channelTitle;

    data.subAvatar = actor?.avatar;
    data.subAvatarPlaceholder = actor?.name;

    data.title = i18n.t('notifications:complaint_received.title', {
      actorName: actor?.name,
      channelTitle,
      courseDates: courseLabel ? `(${courseLabel})` : '',
      /**
       * @i18n_parser
       *
       * t('shared:post.complaint.reason.hate_speech')
       * t('shared:post.complaint.reason.violence')
       * t('shared:post.complaint.reason.terrorism')
       * t('shared:post.complaint.reason.spam')
       * t('shared:post.complaint.reason.other_reason')
       */
      reason: i18n.t(`shared:post.complaint.reason.${complaint!.reason}`),
    });

    if (!complaint?.resolved) {
      data.buttons = [
        {
          id: 'resolve_complaint_button',
          label: i18n.t(
            'notifications:complaint_received.resolve_complaint_button',
          ),
        },
      ];
    }
  }

  return data;
};
